/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import CategoryResponse from "./CategoryResponse";
import PaginationResponse from "./PaginationResponse";
import PaginationRequestSearch from "./PaginationRequestSearch";
import Category from "./Category";

const urls = {
    index(): string {
        return "/category/index";
    }
}

export default {
    urls,
    index(): Promise<CategoryResponse[]> {
        return contentOnly(Axios.get("/category/index", defaultConfig));
    },
    paged(request: PaginationRequestSearch): Promise<PaginationResponse<CategoryResponse>> {
        return contentOnly(Axios.post("/category/paged", request, defaultConfig));
    },
    add(request: Category): Promise<boolean> {
        return contentOnly(Axios.post("/category/add", request, defaultConfig));
    }
}
